import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=2611c7bb&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=2611c7bb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2611c7bb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2611c7bb')) {
      api.createRecord('2611c7bb', component.options)
    } else {
      api.reload('2611c7bb', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=2611c7bb&scoped=true&", function () {
      api.rerender('2611c7bb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2dfpK4DzfU6f6/JS/comp/PopupDialog.vue"
export default component.exports